import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import HeaderLuxury from '../HeaderLuxury';

const TopHeader = ({luxuryHeader, location, pageType, isWorking, appBannerHeight}) => {
  if (luxuryHeader) {
    return (<HeaderLuxury />);
  }
  return (<Header
    appBannerHeight={ appBannerHeight }
    location={ location }
    pageType={ pageType }
    isWorking={ isWorking }
  />);
};

TopHeader.propTypes = {
  luxuryHeader: PropTypes.bool,
  appBannerHeight: PropTypes.number,
  isWorking: PropTypes.bool,
  location: PropTypes.object,
  pageType: PropTypes.string
};

export { TopHeader };
